export interface ILinePayload {
  company_number: string;
  address: string;
  name: string;
  country_code: string;
  phone_type: PhoneType;
  phone_service: PhoneService;
  customer_proof_type: CustomerProofType;
  ein: string;
  customer_proof_website: string;
  file?: File | string;
}

export interface ILineResponse extends ILinePayload {
  _id: string;
  status: LineStatus;
  createdAt: string;
  line_number: string;
}

export enum PhoneType {
  LOCAL = 1,
  TOLL_FREE = 2,
}

export enum PhoneService {
  CALLS_ONLY = 1,
  CALLS_SMS = 2,
}

export enum CustomerProofType {
  WEBSITE_URL = 1,
  UPLOAD_IMG = 2,
}

export enum LineStatus {
  ACTIVE = 1,
  PAUSED = 2,
  MESSAGE_SERVICE_PENDING = 3,
}

export interface IGetLines {
  limit: number;
  page: number;
  line_number: string;
  status?: LineStatus[];
  sort?: Record<string, 1 | -1>;
}

export interface IUpdateLine {
  status: LineStatus;
}
